import * as React from 'react';
import { PropsWithChildren, useMemo } from 'react';
import { initialState, reducer } from 'state/reducers/dictionary';
import { DictionaryContext } from 'models/dictionaryContext';
import { DictionaryActionTypes } from 'state/actions/dictionary';
import { EDictionaryTypes } from 'models/dictionary';
import { getDictionary, getDictionaryPhoneCode } from 'requests/dictionary';

export const DictionaryProvider = ({ children }: PropsWithChildren<{}>) => {
  const [state, dispatch] = React.useReducer(reducer, initialState);

  const getPhoneCode = async () => {
    dispatch({
      type: DictionaryActionTypes.SET_PHONE_CODE,
      payload: [],
    });
    const phoneCodeData = await getDictionaryPhoneCode();
    dispatch({
      type: DictionaryActionTypes.SET_PHONE_CODE,
      payload: phoneCodeData,
    });
  };

  const getCivilianPrefix = async () => {
    dispatch({
      type: DictionaryActionTypes.SET_CIVILIAN_PREFIX,
      payload: [],
    });
    const prefixData = await getDictionary(EDictionaryTypes.civilianPrefix);
    dispatch({
      type: DictionaryActionTypes.SET_CIVILIAN_PREFIX,
      payload: prefixData,
    });
  };

  const getGender = async () => {
    dispatch({ type: DictionaryActionTypes.SET_GENDER, payload: [] });
    const genderData = await getDictionary(EDictionaryTypes.Gender);
    dispatch({ type: DictionaryActionTypes.SET_GENDER, payload: genderData });
  };

  const getMake = async () => {
    dispatch({
      type: DictionaryActionTypes.SET_MAKE,
      payload: [],
    });
    const makeData = await getDictionary(EDictionaryTypes.Make);
    dispatch({
      type: DictionaryActionTypes.SET_MAKE,
      payload: makeData,
    });
  };

  const getMaritalStatus = async () => {
    dispatch({
      type: DictionaryActionTypes.SET_MARITAL_STATUS,
      payload: [],
    });
    const maritalStatusData = await getDictionary(EDictionaryTypes.MaritalStatus);
    dispatch({
      type: DictionaryActionTypes.SET_MARITAL_STATUS,
      payload: maritalStatusData,
    });
  };

  const getIdentificationDocumentType = async () => {
    dispatch({
      type: DictionaryActionTypes.SET_IDENTIFICATION_DOCUMENT_TYPE,
      payload: [],
    });
    const identificationDocumentTypeData = await getDictionary(
      EDictionaryTypes.IdentificationDocumentType,
    );
    dispatch({
      type: DictionaryActionTypes.SET_IDENTIFICATION_DOCUMENT_TYPE,
      payload: identificationDocumentTypeData,
    });
  };

  const getNationalityAll = async () => {
    dispatch({
      type: DictionaryActionTypes.SET_NATIONALITY_ALL,
      payload: [],
    });
    const nationalityData = await getDictionary(EDictionaryTypes.Nationality);
    dispatch({
      type: DictionaryActionTypes.SET_NATIONALITY_ALL,
      payload: nationalityData,
    });
  };

  const value = useMemo(
    () => ({
      ...state,
      getPhoneCode,
      getCivilianPrefix,
      getGender,
      getMake,
      getMaritalStatus,
      getIdentificationDocumentType,
      getNationalityAll,
    }),
    [state],
  );

  return <DictionaryContext.Provider value={value}>{children}</DictionaryContext.Provider>;
};
